import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RequireAuth from '../RequireAuth';
import AppLayout from '../AppLayout';
import ClubPortalSidebar from '../sidebars/ClubPortalSidebar';
import PermissionsPage from '../club_portal/permissions/PermissionsPage';
import NewPermissionPage from '../club_portal/permissions/NewPermissionPage';
import EditPermissionPage from '../club_portal/permissions/EditPermissionPage';
import RolesPage from '../club_portal/roles/RolesPage';
import NewRolePage from '../club_portal/roles/NewRolePage';
import EditRolePage from '../club_portal/roles/EditRolePage';
import UsersPage from '../club_portal/users/UsersPage';
import NewUserPage from '../club_portal/users/NewUserPage';
import EditUserPage from '../club_portal/users/EditUserPage';
import SelectPlanPage from '../club_portal/select-plans/SelectPlanPage';
import ClubPortalDashboard from '../club_portal/ClubPortalDashboard';
import VenuesPage from '../club_portal/venues/VenuesPage';
import NewVenuePage from '../club_portal/venues/NewVenuePage';
import EditVenuePage from '../club_portal/venues/EditVenuePage';
import TurfBookingsPage from '../club_portal/turf_bookings/TurfBookingsPage';
import EditTurfBookingPage from '../club_portal/turf_bookings/EditTurfBookingPage';
import NewTurfBookingPage from '../club_portal/turf_bookings/NewTurfBookingPage';
import GamesPage from '../club_portal/games/GamesPage';
import NewGamePage from '../club_portal/games/NewGamePage';
import ScorecardPage from '../club_portal/games/ScorecardPage';
import LiveScoringPage from '../club_portal/live_scorings/LiveScoringPage';
import ContributionsPage from '../club_portal/contributions/ContributionsPage';
import NewContributionPage from '../club_portal/contributions/NewContributionPage';
import EditContributionPage from '../club_portal/contributions/EditContributionPage';
import OpeningBalancePage from '../club_portal/opening_balances/OpeningBalancePage';
import ClubExpensesPage from '../club_portal/club_expenses/ClubExpensesPage';
import NewClubExpensePage from '../club_portal/club_expenses/NewClubExpensePage';
import EditClubExpensePage from '../club_portal/club_expenses/EditClubExpensePage';
import HeadOfAccountsPage from '../club_portal/head_of_accounts/HeadOfAccountsPage';
import NewHeadOfAccountPage from '../club_portal/head_of_accounts/NewHeadOfAccountPage';
import EditHeadOfAccountPage from '../club_portal/head_of_accounts/EditHeadOfAccountPage';
import MemberLedgersPage from '../club_portal/members_ledgers/MemberLedgersPage';
import UserLedgerPage from '../club_portal/members_ledgers/UserLedgerPage';
import ClubFundPage from '../club_portal/club_funds/ClubFundPage';
import NewSponsorPage from '../club_portal/sponsors/NewSponsorPage';
import EditSponsorPage from '../club_portal/sponsors/EditSponsorPage';
import SponsorsPage from '../club_portal/sponsors/SponsorsPage';
import FundOpeningBalancePage from '../club_portal/club_fund_opening_balances/FundOpeningBalancePage';
import MembersPage from '../club_portal/personal_pages/members/MembersPage';
import MemberDetailPage from '../club_portal/personal_pages/members/MemberDetailPage';
import MyWalletPage from '../club_portal/personal_pages/my_wallet/MyWalletPage';
import MyWalletLedgerPage from '../club_portal/personal_pages/my_wallet/MyWalletLedgerPage';
import ContributionStatementPage from '../club_portal/contributions/ContributionStatementPage';
import ProfilePage from '../profiles/ProfilePage';
import AwardsPage from '../club_portal/awards/AwardsPage';
import ClubEventsPage from '../club_portal/club_events/ClubEventsPage';
import ClubEventManagePage from '../club_portal/club_events/ClubEventManagePage';
import ClubEventForm from '../club_portal/club_events/ClubEventForm';
import BalanceSheetPage from '../club_portal/balance_sheets/BalanceSheetPage';
import GameFinancesPage from '../club_portal/game_finances/GameFinancesPage';
import ClubExpenseStatementPage from '../club_portal/club_expenses/ClubExpenseStatementPage';
import MyAwardsPage from '../club_portal/awards/MyAwardsPage';
import PaymentsViewPage from '../club_portal/payments-view/PaymentsViewPage';
import GenericReportsPage from '../club_portal/reports/GenericReportsPage';

const ClubPortalRoutes = () => {
  return (
    <Routes>
      {/* All paths are now relative */}
      <Route
        path="permissions"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <PermissionsPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="permissions/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <NewPermissionPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="permissions/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <EditPermissionPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="roles"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <RolesPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="roles/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <NewRolePage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="roles/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <EditRolePage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="users"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <UsersPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="users/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <NewUserPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="users/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <EditUserPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="select-plan"
        element={
          <RequireAuth>
            {/* The SelectPlanPage should probably not have the main AppLayout with sidebar */}
            <SelectPlanPage />
          </RequireAuth>
        }
      />
      <Route
        path="dashboard"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <ClubPortalDashboard />
            </AppLayout>
          </RequireAuth>
        }
      />

      <Route
        path="venues"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <VenuesPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="venues/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <NewVenuePage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="venues/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <EditVenuePage />
            </AppLayout>
          </RequireAuth>
        }
      />

      <Route
        path="bookings"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <TurfBookingsPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="bookings/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <NewTurfBookingPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="bookings/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <EditTurfBookingPage />
            </AppLayout>
          </RequireAuth>
        }
      />


      {/* --- Game Routes --- */}
      <Route
        path="games"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <GamesPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="games/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <NewGamePage />
            </AppLayout>
          </RequireAuth>
        }
      />

      <Route
        path="games/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <ScorecardPage />
            </AppLayout>
          </RequireAuth>
        }
      />

      {/* --- New Live Scoring Route --- */}
      <Route
        path="games/:id/score"
        element={
          <RequireAuth>
            {/* Live scoring is a full-screen experience, so we don't use the AppLayout here */}
            <LiveScoringPage />
          </RequireAuth>
        }
      />


      {/* --- Financial Routes --- */}
      <Route path="game-finances" element={<RequireAuth><AppLayout sidebar={<ClubPortalSidebar />}><GameFinancesPage /></AppLayout></RequireAuth>} />
      <Route path="contributions" element={<RequireAuth><AppLayout sidebar={<ClubPortalSidebar />}><ContributionsPage /></AppLayout></RequireAuth>} />
      <Route path="contributions/create/:slotId" element={<RequireAuth><AppLayout sidebar={<ClubPortalSidebar />}><NewContributionPage /></AppLayout></RequireAuth>} />
      <Route path="contributions/edit/:slotId" element={<RequireAuth><AppLayout sidebar={<ClubPortalSidebar />}><EditContributionPage /></AppLayout></RequireAuth>} />
      <Route path="contributions/statement/:slotId" element={<RequireAuth><AppLayout sidebar={<ClubPortalSidebar />}><ContributionStatementPage /></AppLayout></RequireAuth>} />



      <Route path="opening-balances" element={<RequireAuth><AppLayout sidebar={<ClubPortalSidebar />}><OpeningBalancePage /></AppLayout></RequireAuth>} />

      {/* --- Club Expense Routes --- */}
      <Route
        path="expenses"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <ClubExpensesPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="expenses/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <NewClubExpensePage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="expenses/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <EditClubExpensePage />
            </AppLayout>
          </RequireAuth>
        }
      />

      <Route
        path="expenses/statement/:expenseId"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <ClubExpenseStatementPage />
            </AppLayout>
          </RequireAuth>
        }
      />

      

      <Route
        path="head-of-accounts"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <HeadOfAccountsPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="head-of-accounts/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <NewHeadOfAccountPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="head-of-accounts/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <EditHeadOfAccountPage />
            </AppLayout>
          </RequireAuth>
        }
      />


      <Route
        path="/financials/ledgers"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <MemberLedgersPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/financials/ledgers/:userId"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <UserLedgerPage />
            </AppLayout>
          </RequireAuth>
        }
      />




      <Route
        path="/sponsors"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <SponsorsPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/sponsors/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <NewSponsorPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/sponsors/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <EditSponsorPage />
            </AppLayout>
          </RequireAuth>
        }
      />


      <Route
        path="/financials/club-fund"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <ClubFundPage />
            </AppLayout>
          </RequireAuth>
        }
      />

      <Route
        path="/financials/club-fund-opening-balance"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <FundOpeningBalancePage />
            </AppLayout>
          </RequireAuth>
        }
      />


       <Route
        path="/members"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <MembersPage />
            </AppLayout>
          </RequireAuth>
        }
      />
       <Route
        path="/members/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <MemberDetailPage />
            </AppLayout>
          </RequireAuth>
        }
      />


 <Route
        path="/my-wallet"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <MyWalletPage />
            </AppLayout>
          </RequireAuth>
        }
      />

 <Route
        path="/my-awards"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <MyAwardsPage />
            </AppLayout>
          </RequireAuth>
        }
      />



 <Route
        path="/my-wallet/ledger"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <MyWalletLedgerPage />
            </AppLayout>
          </RequireAuth>
        }
      />


 <Route
        path="/awards"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <AwardsPage />
            </AppLayout>
          </RequireAuth>
        }
      />


      <Route
        path="/profile"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <ProfilePage />
            </AppLayout>
          </RequireAuth>
        }
      />


      <Route
        path="/club-events"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <ClubEventsPage />
            </AppLayout>
          </RequireAuth>
        }
      />

      <Route
        path="/club-events/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <ClubEventForm mode="create"  />
            </AppLayout>
          </RequireAuth>
        }
      />

      <Route
        path="/club-events/:clubEventId/edit"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <ClubEventForm mode="edit" />
            </AppLayout>
          </RequireAuth>
        }
      />

      <Route
        path="/club-events/:clubEventId/manage"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <ClubEventManagePage />
            </AppLayout>
          </RequireAuth>
        }
      />


       <Route
        path="/balance-sheet"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
            <BalanceSheetPage/>
            </AppLayout>
          </RequireAuth>
        }
      />


       <Route
        path="payments-view"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <PaymentsViewPage />
            </AppLayout>
          </RequireAuth>
        }
      /> 
      
      <Route
        path="/reports/club-finance"
        element={
          <RequireAuth>
            <AppLayout sidebar={<ClubPortalSidebar />}>
              <GenericReportsPage module="club_finance" moduleTitle="Club Finance" />
            </AppLayout>
          </RequireAuth>
        }
      />




    </Routes>


  );
};

export default ClubPortalRoutes;
